import React, { Component } from "react";
import { Container } from "reactstrap";

class Home extends Component {
  render() {
    return (
      <Container className="mt-4">
        <h1 className="display-4">Need help?</h1>
        <p>
          If you're having trouble submitting a request, please let us know:
        </p>
        <a href="mailto:mnaylor@utk.edu?subject=Error%20with%20media%20request">
          Email
        </a>
      </Container>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Help/Help.js